import { useEffect } from "react";

import QuoteGtmEvent from "@/types/gtm/QuoteGtmEvent";

import { defaultViewQuoteData } from "./default-view-quote-data";

type DataLayerItem = QuoteGtmEvent | { ecommerce: null };

export interface ExtendedWindow extends Window {
  dataLayer?: DataLayerItem[];
}

type PageLoadProps = {
  quoteData: Partial<QuoteGtmEvent | null>;
  isReady: boolean;
};

const useGtmViewQuoteData = (props: PageLoadProps) => {
  const { quoteData, isReady } = props;
  useEffect(() => {
    const triggerPageLoadEvent = () => {
      if (quoteData !== null) {
        const extendedWindow = window as ExtendedWindow;
        extendedWindow.dataLayer = extendedWindow.dataLayer ?? [];

        // clear ecommerce data
        extendedWindow.dataLayer.push({ ecommerce: null });

        const eventData = { ...defaultViewQuoteData, ...quoteData };

        // push the actual event data
        extendedWindow.dataLayer.push({
          ...eventData,
        });
      }
    };
    if (isReady) triggerPageLoadEvent();
    return () => {
      // Cleanup code if needed
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);
};

export default useGtmViewQuoteData;
